export default (settings = {}) => ({
  ...settings,
  data: null,
  loaded: false,

  async init() {
    const response = await fetch(this.apiUrl);
    const json = await response.json();

    this.data = json;
    this.loaded = true;
  },
});
